function secondLevelDomain(domain) {
  const tokens = domain.split(".")
  if (tokens.length < 2) {
    return ""
  }
  return `${tokens[tokens.length - 2]}.${tokens[tokens.length - 1]}`
}

export default secondLevelDomain;